import { ActivatedRoute, Router } from '@angular/router';
import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';

import { RegistrationService, UserService } from '~auth/services';
import { matchingPasswords } from '~auth/validators/validators';
import { AUTH_CONFIG, AuthConfig } from '~auth/providers/auth.provider';

@Component({
  selector: 'reset-password',
  template: '',
  styleUrls: ['./reset-password.page.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ResetPasswordPage {
  email: Observable<string>;
  requestId: Observable<string>;
  private resetPassForm: FormGroup;
  public showError: boolean = false;
  failureResponse: string;
  successResponse: string;

  constructor(
    route: ActivatedRoute,
    private fb: FormBuilder,
    private userService: UserService,
    private router: Router, private registrationService: RegistrationService, @Inject(AUTH_CONFIG) private authConfig: AuthConfig) {
    this.requestId = route.queryParams.map((p) => p.requestId).distinctUntilChanged();
    this.email = route.queryParams.map((p) => p.email).distinctUntilChanged();

    this.resetPassForm = this.fb.group({
      password: [null, Validators.required],
      confirmPassword: [null, Validators.required]
    }, { validator: matchingPasswords('password', 'confirmPassword') });
  }


  resetPassword() {
    let password = this.resetPassForm.get('password').value;
    this.requestId.flatMap((requestId: string) => this.registrationService.resetPassword(requestId, password))
      .take(1)
      .subscribe(response => {
        if (!!response['type'] && response['type'] == 'S') {
          this.proceedLogin();
        }
      }, error => {
        this.failureResponse = 'Reset Password Failed. Please contact admin.'
      });
  }


  proceedLogin() {
    this.email
      .take(1)
      .subscribe(email => {
        this.userService.signIn(email, this.resetPassForm.get('password').value)
          .take(1)
          .subscribe(response => {
            if (!!response) {
              this.successResponse = 'Reset Password Successful. Redirecting to Home page..'
              setTimeout((router: Router) => {
                this.router.navigate([this.authConfig.redirectUrl]);
              }, 2000);
            }
            this.showError = false;
          }, error => {
            this.failureResponse = 'Failed to signin with new credentials. Please contact admin.'
          });
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/auth/pages/reset-password.page.ts